import { render } from "./FormularioBaseProcesso.vue?vue&type=template&id=3e5cc70c&scoped=true"
import script from "./FormularioBaseProcesso.vue?vue&type=script&lang=js"
export * from "./FormularioBaseProcesso.vue?vue&type=script&lang=js"

import "./FormularioBaseProcesso.vue?vue&type=style&index=0&id=3e5cc70c&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5cc70c"],['__file',"src/views/Legalize/CadastroDeProcessos/Components/FormularioBaseProcesso.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e5cc70c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e5cc70c', __exports__)) {
    console.log('reload')
    api.reload('3e5cc70c', __exports__)
  }
  
  module.hot.accept("./FormularioBaseProcesso.vue?vue&type=template&id=3e5cc70c&scoped=true", () => {
    console.log('re-render')
    api.rerender('3e5cc70c', render)
  })

}


export default __exports__